module.exports = __webpack_public_path__ + "img/T2B_rc_11.a92fbe78.png";